export const isElementFocusable = (element: Element) => {
    const focusableTagNames = ["INPUT", "SELECT", "TEXTAREA"];

    if (focusableTagNames.includes(element.tagName)) {
        return true;
    }
    return false;
};

export const isInViewport = (element: Element, pixelsVisible = 0) => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const { top, bottom } = element.getBoundingClientRect();

    // biome-ignore lint/complexity/noUselessTernary: <>
    return viewportHeight - top > pixelsVisible && bottom > pixelsVisible ? true : false;
};

export const isBuiltWithWix = () => {
    const metas = Array.from(document.getElementsByTagName("meta"));
    for (const meta of metas) {
        if (
            meta.getAttribute("name") === "generator" &&
            meta.getAttribute("content")?.toLowerCase().includes("wix")
        ) {
            return true;
        }
    }

    return false;
};

export const getDefaultFontSize = () => {
    const element = document.createElement("div");
    element.style.width = "1rem";
    element.style.display = "none";
    document.body.append(element);

    const widthMatch = window.getComputedStyle(element).getPropertyValue("width").match(/\d+/);

    element.remove();

    if (!widthMatch || widthMatch.length < 1) {
        return null;
    }

    const result = Number(widthMatch[0]);
    return !Number.isNaN(result) ? result : null;
};
